<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Generate OTP</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              <a href="#">Kependudukan</a>
            </div>
            <div class="breadcrumb-item">
              Generate OTP
            </div>
          </div>
        </div>
        <div class="section-body">
          <div class="card card-primary">
            <div class="card-header">
              <h4 class="d-inline">
                Generate OTP Akun Penduduk
              </h4>
              <div class="card-header-action">
                <button
                  id="btnRefresh"
                  class="btn btn-primary"
                  title="Refresh"
                  @click="loadPostsData"
                >
                  <i class="fa fa-sync" />
                </button>
              </div>
            </div>
            <div class="card-body">
              <AkunTable
                :items="items" 
                :fields="fields" 
                :meta="meta" 
                :edit-url="'/a/b'"
                :aksi="'generateotp'"
                :loading="tableLoading"
                @per_page="handlePerPage" 
                @pagination="handlePagination" 
                @search="handleSearch" 
                @sort="handleSort" 
                @handleGenerateOtp="handleGenerateOtp"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
    <b-modal
      id="modal-generate-otp"
      :title="'Generate OTP'"
    >
      <div v-if="penduduk">
        <p>Generate OTP untuk {{ penduduk.penduduk.nama_lengkap }}</p>
        <div class="text-center">
          <button
            class="btn btn-primary"
            @click="generateOtp($event)"
          >
            <i class="fa fa-check mr-2" />Generate OTP
          </button>

          <div
            v-if="otpGenerated"
            class="mt-3"
          >
            <span class="otp">{{ kodeOtp }}</span><br>
          </div>
        </div>

        <div v-if="penduduk">
          <div v-if="penduduk.is_ktp_verified == 1">
            <p class="mt-3">
              Terdapat Foto KTP yang diunggah
            </p>
            <img
              :src="imgKtp"
              class="w-100"
            >
            <!-- <img :src="$store.getters.getBaseUrl + '/api/berkasPendaftaran/showSelfieKtp?id_penduduk=' + penduduk.id_penduduk"> -->
            <!-- <img class="w-100" src="https://www.kai.or.id/wp-content/uploads/2019/03/ekt-wna.jpg"> -->
          </div>
        </div>
      </div>
			
			
      <template #modal-footer>
        <button
          type="button"
          value=""
          class="btn btn-secondary"
          @click="$bvModal.hide('modal-generate-otp')"
        >
          <i class="fa fa-times mr-2" />Tutup
        </button>
      </template>
    </b-modal>
  </LayoutAdmin>
</template>

<style scoped>
	.otp {
		font-size: 2rem;
		background: #eee;
		padding: 10px 20px;
		border-radius: 5px;
	}
</style>

<script>
import NProgress from 'nprogress'
import swal from 'sweetalert'
import LayoutAdmin from './../layouts/Admin.vue'
import AkunTable from './../../components/table/AkunTable.vue' //IMPORT COMPONENT DATATABLENYA

export default {
  data() {
    return {
      //UNTUK VARIABLE FIELDS, DEFINISIKAN KEY UNTUK MASING-MASING DATA DAN SORTABLE BERNILAI TRUE JIKA INGIN MENAKTIFKAN FITUR SORTING DAN FALSE JIKA TIDAK INGIN MENGAKTIFKAN
      fields: [
        { key: 'no' },
        { key: 'nama_pemilik', label: 'Nama', sortable: true },
        { key: 'desa', sortable: true },
        { key: 'email', sortable: true },
        { key: 'username', sortable: true },
        { key: 'no_hp', sortable: true },
        { key: 'is_aktif', label: 'Verifikasi OTP', sortable: true },
        { key: 'created_at', label: 'Tanggal Daftar', sortable: true },
        { key: 'actions', sortable: false }, //TAMBAHKAN CODE INI
        // {key: 'category', sortable: true},
        // {key: 'created_at', sortable: true}
      ],
      filter: {
        role: 'Penduduk',
        is_disabled: { id: 0, label: 'Aktif' },
        is_multi_role: false,
        id_kecamatan: { id_kecamatan: 0, nama_kecamatan: 'SEMUA KECAMATAN' },
        id_desa: { id_desa: 0, nama_desa: 'SEMUA DESA' },
      },
      items: [], //DEFAULT VALUE DARI ITEMS ADALAH KOSONG
      meta: {}, //JUGA BERLAKU UNTUK META
      current_page: 1, //DEFAULT PAGE YANG AKTIF ADA PAGE 1
      per_page: 10, //DEFAULT LOAD PERPAGE ADALAH 10
      search: '',
      sortBy: 'created_at', //DEFAULT SORTNYA ADALAH CREATED_AT
      sortByDesc: false, //ASCEDING,
      tableLoading: true,


      otpGenerated: false,
      kodeOtp: null,
      imgKtp: ''
    }
  },
  computed: {
    penduduk() {
      return this.$store.getters.getPendudukBantu
    }
  },
  components: {
    LayoutAdmin, AkunTable
  },
  methods: {
    //METHOD INI AKAN MENGHANDLE REQUEST DATA KE API
    loadPostsData() {
      this.tableLoading = true
      NProgress.start()
      let button = document.querySelector('#btnRefresh')
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-sync"></i>'

      let current_page = this.search == '' ? this.current_page : 1




      let role = this.$store.getters.getAuthService.currentRole.nama_role

      let dispatchAkun = 'getAllAkun'
      if (role === 'Operator Desa' || role === 'Kepala Desa') {
        dispatchAkun = 'getAkunByDesa'
      }

      // if(role === 'Operator Desa' || role === 'Kepala Desa'){
      //     dispatchAkun = 'getAkunByDesa'
      // } else if(role === 'Operator Kecamatan'){
      //     dispatchAkun = 'getAkunByKecamatan'
      // } else if(role === 'Operator Dukcapil' || role === 'Operator Dukcapil Kecamatan' || role === 'Admin Laksita' || role === 'Admin Jembrana'){
      //     dispatchAkun = 'getAllAkun'
      // }


      let data = {
        page: current_page,
        per_page: this.per_page,
        q: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC' : 'ASC',
        role: this.filter.role,
        is_disabled: this.filter.is_disabled.id,
        is_multi_role: this.filter.is_multi_role,
      }

      this.$store.dispatch(dispatchAkun, data).then((response) => {
        // PARSE DATE
        let date = ''
        let created_at = ''
        // let created_at_hours = ''
        response.data.data.data.forEach(e => {
          e.nama_pemilik = (e.penduduk) ? e.penduduk.nama_lengkap : '-'
          date = new Date(e.created_at)
          created_at = date.toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: 'numeric' })
          created_at += ' ' + date.toLocaleTimeString('it-IT')
          e.created_at = created_at
        })
        //JIKA RESPONSENYA DITERIMA
        let getData = response.data.data
        this.items = getData.data //MAKA ASSIGN DATA POSTINGAN KE DALAM VARIABLE ITEMS
        //DAN ASSIGN INFORMASI LAINNYA KE DALAM VARIABLE META
        this.meta = {
          total: getData.total,
          current_page: getData.current_page,
          per_page: getData.per_page,
          from: getData.from,
          to: getData.to
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
        NProgress.done()
        this.tableLoading = false
      })
    },
    //JIKA ADA EMIT TERKAIT LOAD PERPAGE, MAKA FUNGSI INI AKAN DIJALANKAN
    handlePerPage(val) {
      this.per_page = val //SET PER_PAGE DENGAN VALUE YANG DIKIRIM DARI EMIT
      this.loadPostsData() //DAN REQUEST DATA BARU KE SERVER
    },
    //JIKA ADA EMIT PAGINATION YANG DIKIRIM, MAKA FUNGSI INI AKAN DIEKSEKUSI
    handlePagination(val) {
      this.current_page = val //SET CURRENT PAGE YANG AKTIF
      this.loadPostsData()
    },
    //JIKA ADA DATA PENCARIAN
    handleSearch(val) {
      this.search = val //SET VALUE PENCARIAN KE VARIABLE SEARCH
      this.loadPostsData() //REQUEST DATA BARU
    },
    //JIKA ADA EMIT SORT
    handleSort(val) {
      //MAKA SET SORT-NYA
      this.sortBy = val.sortBy
      this.sortByDesc = val.sortDesc

      this.loadPostsData() //DAN LOAD DATA BARU BERDASARKAN SORT
    },
    handleDelete(val) {
      // console.log(val)
    },
    handleGenerateOtp(data) {
      this.$store.dispatch('setPendudukBantu', data)

      setTimeout(() => {
        console.log(this.penduduk)
      }, 1000)

      this.otpGenerated = false
      this.kodeOtp = null

      if (data) {
        if (data.is_ktp_verified == 1) {
          this.showImgKtp()
        } else {
          this.imgKtp = ''
        }
      } else {
        this.imgKtp = ''
      }


      this.$bvModal.show('modal-generate-otp')

    },
    showImgKtp() {
      this.$store.dispatch('showSelfieKtp', this.penduduk.penduduk.id_penduduk).then(res => {
        let u8 = new Uint8Array(res.data)
        let b64encoded = btoa([].reduce.call(new Uint8Array(res.data), function (p, c) { return p + String.fromCharCode(c) }, ''))
        let mimetype = "image/jpeg"
        this.imgKtp = "data:" + mimetype + ";base64," + b64encoded
      })
    },
    toHHMMSS(val) {
      var sec_num = parseInt(val, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var seconds = sec_num - (hours * 3600) - (minutes * 60);

      if (hours < 10) { hours = "0" + hours; }
      if (minutes < 10) { minutes = "0" + minutes; }
      if (seconds < 10) { seconds = "0" + seconds; }
      return hours + ':' + minutes + ':' + seconds;
    },
    generateOtp(e) {
      let button = e.target
      let buttonHtml = button.innerHTML

      this.loading = true

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Generate OTP'


      this.$store.dispatch('generateOtp', this.penduduk.id_penduduk).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.kodeOtp = res.data.data.kode_otp
          this.otpGenerated = true
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })

        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      }).catch(err => {
        // console.log(err)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml

      })
    }
  },
  mounted() {
    //MAKA AKAN MENJALANKAN FUNGSI BERIKUT
    this.loadPostsData()
  }
}
</script>